
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { installErrorMonitoring } from '@/lib/monitoring'
import ErrorBoundary from '@/components/ErrorBoundary'

// Global browser error + unhandled rejection capture, installed before render
// so a crash during the first paint is still reported.
installErrorMonitoring();

createRoot(document.getElementById("root")!).render(
  <ErrorBoundary area="root">
    <App />
  </ErrorBoundary>
);
